import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actions, dashboardFilterSelector } from "libLegacy/ducks/dashboard";
import { AppDispatch } from "libLegacy/ducks/state";
import { FilterDashboard } from "libLegacy/api/models";

export function useFilter() {
  const dispatch: AppDispatch = useDispatch();
  const filter = useSelector(dashboardFilterSelector);
  const update = React.useCallback(
    (f: Partial<FilterDashboard>) => {
      dispatch(actions.mergeFilter(f));
    },
    [dispatch]
  );

  return [filter, update] as [typeof filter, typeof update];
}
